import { ReactElement, useState } from 'react';
import aiStyles from '@/styles/pages/admin/ai.module.less';
import { MessageOutlined } from '@ant-design/icons';
import { AiComponentContext } from '@/context';
import SmartAssistantContainer from './SmartAssistantContainer';
import CheckLogin from '@/views/admin/components/CheckLogin';
const AiComponent = (): ReactElement => {
    const [visible, setVisible] = useState(false);
    const [conversationId, setConversationId] = useState<string>('');
    const [openHistory, setOpenHistory] = useState(false);
    return (
        <>
            {/* 控制按钮 */}
            <div className={aiStyles['assistant-toggle-button']} onClick={() => setVisible(!visible)}>
                <MessageOutlined style={{ fontSize: 24 }} />
            </div>
            {/* 智能助手窗口 */}
            {visible && (
                <AiComponentContext.Provider value={{ visible, setVisible, setOpenHistory, openHistory, conversationId, setConversationId }}>
                    <CheckLogin>
                        <div className={aiStyles['assistant-popup']}>
                            <SmartAssistantContainer />
                        </div>
                    </CheckLogin>
                </AiComponentContext.Provider>
            )}
        </>
    );
};

export default AiComponent;
